import NCMService from "@/services/NCMService"

export const actions = {
    cadastrarNCM: ({commit, dispatch}) => {
        commit('setNCM', {
            nome: "",
            agencia: "",
            conta: "",
            código_NCM: "",
            saldo_atual: "",
        }),
        dispatch('setModalCadastroNCM', true)
    },
    listarNCMs: ({commit}, data) => {
        commit('setOverlay', true)
        NCMService.listar(data)
        .then(res => {
            commit('setOverlay', false)
            commit('setNCMs', res.data)
        })
        .catch(e => {
            commit('setOverlay', false)
            console.log(e)
        })
    },
    visualizarNCM: ({commit, dispatch}, data) => {
        commit('setNCM', {...data})
        dispatch('setModalCadastroNCM', true)
    },
    salvarNCM: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        NCMService.salvar(data)
        .then(res => {
            // commit('addNCM', res.data)
            commit('setNCM', res.data)
            commit('setOverlay', false)
            commit('snackbarSuccess', 'NCM cadastrado.')
            dispatch('listarNCMs', {})
            dispatch('setModalCadastroNCM', false)
        })
        .catch(e => {
            // if(e.response.status == 422){
            //     commit('alertError', e.response.data.errors)
            // }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao cadastrar.')
        })
    },
    atualizarNCM: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        NCMService.atualizar(data)
        .then(res => {
            commit('setOverlay', false)
            commit('snackbarInfo', 'NCM atualizado.')
            dispatch('listarNCMs', {})
        })
        .catch(e => {
            // if(e.response.status == 422){
            //     commit('alertError', e.response.data.errors)
            // }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao atualizar.')
        })
    },
    excluirNCM: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        dispatch('setModalExcluirNCM', false)
        dispatch('setModalCadastroNCM', false)
        NCMService.excluir(data.id)
        .then(res => {
            dispatch('listarNCMs', {})
            commit('setOverlay', false)
            commit('snackbarError', 'NCM excluído.')
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao excluir NCM.')
        })
    },
    setModalCadastroNCM: ({commit}, status) => {
        commit('setModalCadastrarNCM', false)
        setTimeout(() => {
            commit('setModalCadastrarNCM', status)
        }, 100);
    },
    setModalAtualizarTabelaNCM: ({commit}, status) => {
        commit('setModalAtualizarTabelaNCM', false)
        setTimeout(() => {
            commit('setModalAtualizarTabelaNCM', status)
        }, 100);
    },
    setModalExcluirNCM: ({commit}, status) => {
        commit('setModalExcluirNCM', false)
        setTimeout(() => {
            commit('setModalExcluirNCM', status)
        }, 100);
    },
    atualizarTabelaNCM: ({commit, dispatch}) => {
        commit('setOverlay', true)
        NCMService.atualizarTabela()
        .then(res => {
            commit('setOverlay', false)
            commit('snackbarSuccess', 'Tabela atualizada com sucesso.')
            dispatch('setModalAtualizarTabelaNCM', false)
            dispatch('listarNCMs', {})
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao atualizar.')
        })
    }
}

export default {}